export const LOCALSTORAGE_PAYMENT_DONE = "vStoryLinksPaymentDone";
export const LOCALSTORAGE_PAYMENT_CURRENCY = "vStoryLinksPaymentCurrency";